<template>
    <PageHeader :page="page" :template="'2'" @action="createNew" v-if="!state.loading"/>
    <div class="content" v-if="!state.loading">
        <DataTable :tableData="tableData" @add="addI" 
        @edit_template="editTemplate" @edit_item="editItem"
        @delete_template="deleteTemplate"/>
    </div>
    <div v-if="state.loading" style="text-align: center;">
      <img src="@/assets/img/ajldr.gif" style="width:100px"/>
    </div>

    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm :columns="1"
        :fields="newFields" @submit="addTemplate"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" />
    </ModalView> 

    <ModalView
        :isVisible="state.addItemModal"
        :fixclose="true"
        @close="state.addItemModal = false">
        
        <DynamicForm :columns="1"
        :fields="itemFields" @submit="addItem" :addMore="'Add Item'"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" @sendData="addMoreItem"/>
    </ModalView> 

    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">
        
        <DynamicForm :columns="1"
        :fields="editFields" @submit="addTemplate" 
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success"/>
    </ModalView> 

    <ModalView
        :isVisible="state.editItemModal"
        :fixclose="true"
        @close="state.editItemModal = false">
        
        <DynamicForm :columns="1" v-if="!state.modalLoading"  :addMore="'Add Item'"
        :fields="editFields" @submit="updateItem" @field-removed="deleteItem"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" @sendData="addMoreEditItem"/>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </ModalView> 

</template>
<script>
import icons from '@/assets/js/icons.js';
import { useStore } from 'vuex';
import { reactive, ref, computed, onMounted} from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import { usePermissions } from '@/composables/usePermissions';
import DynamicForm from '@/components/DynamicForm.vue';
import ModalView from '@/components/ModalView.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
import DataTable from '@/components/DataTable.vue';
export default {
    name: 'TransactionsView',
    components:{PageHeader,DynamicForm,ModalView,DataTable},
    setup(){
        const store= useStore();
        const system = computed(() => store.state.System.system);
        const { hasPermission } = usePermissions();
        var payacct=false;
        const state=reactive({CreateModal:false, submitting:false,error:[],success:false,
        loading:true,addItemModal:false,editModal:false,editItemModal:false,modalLoading:false
        });
        const itemOptions=ref([
            {label:"Deduction", value:"Deduction"},
            {label:"Allowance", value:"Allowance"}
        ])
        var action_label=[icons.plus];
        var action=["add"];
        const editFields=ref([]);
        const page=ref({title:"Pay Template", btn:"Create",
            desc:"Set up salary plans with bonuses and deductions, and adjust them for each staff when needed"})
        if(!hasPermission('Payroll', 'create')){
            page.value.btn="";
        }
        if(hasPermission('Payroll', 'edit')){
            action_label.push(icons.edit);
            action.push("edit_template");
            action_label.push(icons.edit2);
            action.push("edit_item");
        }

        if(hasPermission('Payroll', 'delete')){
            action_label.push(icons.trash);
            action.push("delete_template");
        }

        function createNew(){
            if(system.value.acct_type==""){
                alert("Office accounting settings not found. Please contact your system administrator to configure accounting settings to continue")
                return;
            }else if(system.value.acct_type=="full"){
                if(!payacct){
                    alert("Your salary account isn't set up yet. Please reach out to your system administrator for assistance");
                    return;
                }
            }
            state.submitting=false;
            state.success=false;
            state.error=[]
            state.CreateModal=true;
        }
        

        const newFields=ref([
            { name: "Create Template", number: "1",data: 
                [{ type: 'text', name: 'name', label: 'Name',
                value: ""  },
                { type: 'text', name: 'base', label: 'Base Salary',
                    value: ""},
                ]
            }
        ])

        const itemFields=ref([]);

        function addTemplate(data){
            state.submitting=true;
            state.errors=[];
            data.addTemplate="";
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg);
                }else{
                    setErrors(res)
                }
                }
            })
        }

        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "Name" },
                { label: "Base Salary" },
                { label: "Total Items" },
                { label: "Total" },
            ],
            options:{
                label:"Actions",
                action_label:action_label,
                action:action
            },
            total:0
        });

        function setErrors(res){
            var errors=[];
            Object.keys(res.msg).forEach(key => {
            var e=res.msg[key],er="";
            Object.keys(e).forEach(k => {
                er+=er=="" ? e[k] : ", "+e[k]
            })
            errors.push(er);
            });
            state.errors=errors;
        }

        function setTable(msg){
            var data={}
            tableData.value.loading = false;
            tableData.value.rows.length=0
            Object.keys(msg).forEach(set => {
                data={id:msg[set].id};
                var v=[];
                Object.keys(msg[set].val).forEach(row => {
                v.push(msg[set].val[row])
                });
                data.val=v;
                tableData.value.rows.push(data)
            });
            tableData.value.total=tableData.value.rows.length
        }

        

        onMounted(() => {
            call({
                url:urls.transactions,
                data:{startPayroll:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        var d=res.msg;
                        payacct=d.pay_acct;
                        setTable(d.table);
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function addI(i){
            var t_id=tableData.value.rows[i].id;
            itemFields.value.length=0;
            itemFields.value.push(
                { name: "Add Item", number: "1",data: 
                    [{ type: 'text', name: 'name_1', label: 'Name',
                    value: ""  },
                    { type: 'select', name: 'type_1', label: 'Item type',
                        value: "",options:itemOptions
                    },
                    { type: 'text', name: 'amount_1', label: 'Amount',
                    value: ""  },
                    { type: 'hidden', name: 'template_1',value: t_id  },
                    ]
                }
            )
            state.addItemModal=true;
            state.submitting=false;
            state.success=false;
            state.error=[]
        }

        function addMoreItem(f){
            var t_id =f["template_1"];
            for(var i=0; i<itemFields.value.length; i++){
                itemFields.value[i].data.forEach(field => {
                if (f[field.name]) {
                    field.value = f[field.name];
                }
                });
            }
            itemFields.value.push(
                { name: "Add Item", number: (itemFields.value.length+1).toString(),
                    data: 
                        [{ type: 'text', name: 'name_'+(itemFields.value.length+1).toString(), label: 'Name',
                        value: ""  },
                        { type: 'select', name: 'type_'+(itemFields.value.length+1).toString(), label: 'Item type',
                            value: "",options:[
                                {label:"Deduction", value:"Deduction"},
                                {label:"Allowance", value:"Allowance"},
                            ]
                        },
                        { type: 'text', name: 'amount_'+(itemFields.value.length+1).toString(), label: 'Amount',
                        value: ""  },
                        { type: 'hidden', name: 'template_'+(itemFields.value.length+1).toString(),value: t_id  },
                        ]
                }
            )
        }

        function addMoreEditItem(f){
            var t_id =f["template_1"];
            for(var i=0; i<editFields.value.length; i++){
                editFields.value[i].data.forEach(field => {
                if (f[field.name]) {
                    field.value = f[field.name];
                }
                });
            }
            editFields.value.push(
                { name: "Add Item", number: (editFields.value.length+1).toString(), id:"new",
                    data: 
                        [{ type: 'text', name: 'name_'+(editFields.value.length+1).toString(), label: 'Name',
                        value: "",  },
                        { type: 'select', name: 'type_'+(editFields.value.length+1).toString(), label: 'Item type',
                            value: "",options:[
                                {label:"Deduction", value:"Deduction"},
                                {label:"Allowance", value:"Allowance"},
                            ]
                        },
                        { type: 'text', name: 'amount_'+(editFields.value.length+1).toString(), label: 'Amount',
                        value: ""  },
                        { type: 'hidden', name: 'template_'+(editFields.value.length+1).toString(),value: t_id  },
                        { type: 'hidden', name: 'id_'+(editFields.value.length+1).toString(),value: "new"  },
                        ]
                }
            )
        }

        function addItem(data){
            state.submitting=true;
            state.errors=[];
            data.addPayItem=(itemFields.value.length).toString();
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg.table);
                    if(res.msg.error != ""){
                        alert(res.msg.error)
                    }
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function updateItem(data){
            state.submitting=true;
            state.errors=[];
            data.addPayItem=(editFields.value.length).toString();
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg.table);
                    if(res.msg.error != ""){
                        alert(res.msg.error)
                    }
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function editTemplate(i){
            var data=tableData.value.rows[i];
            var t_id=data.id;
            editFields.value.length=0;
            editFields.value.push(
                { name: "Edit Template", number: "1",data: 
                    [{ type: 'text', name: 'name', label: 'Name',
                    value: data.val[0] },
                    { type: 'text', name: 'base', label: 'Base Salary',
                        value: data.val[1].replace(/[^0-9,.]/g, '')},
                    { type: 'hidden', name: 'id',value: t_id  }]
                }
            )
            state.editModal=true;
            state.submitting=false;
            state.success=false;
            state.error=[]
        }

        function editItem(i){
            var id=tableData.value.rows[i].id;
            state.editItemModal=true;
            state.submitting=false;
            state.success=false;
            state.modalLoading=true;
            editFields.value.length=0;
            state.error=[]
            call({
                url:urls.transactions,
                data:{getPayItem:id},
                success:(res)=>{
                state.modalLoading=false;
                if(res.status){
                    var i=1;
                    Object.keys(res.msg).forEach(key => {
                        var d= res.msg[key];
                        editFields.value.push(
                            { name: "Edit Item", number: i, deletable:true, id:d.id,
                                data: 
                                    [{ type: 'text', name: 'name_'+i, label: 'Name',
                                    value: d.name},
                                    { type: 'select', name: 'type_'+i, label: 'Item type',
                                        value: d.type,options:itemOptions
                                    },
                                    { type: 'text', name: 'amount_'+i, label: 'Amount',
                                    value: d.amount  },
                                    { type: 'hidden', name: 'template_'+i,value: id  },
                                    { type: 'hidden', name: 'id_'+i,value: d.id  },
                                    ]
                            }
                        )
                        i++;
                    })
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function deleteItem({updatedFormSets,  deleted, data }) {
            if(deleted.fieldIndex){
                editFields.value[deleted.setIndex].data[deleted.fieldIndex].deleting=true;
            }else{
                editFields.value[deleted.setIndex].deleting=true;
            }
            
            var id=editFields.value[deleted.setIndex].id;
            if(id=="new"){
                editFields.value=updatedFormSets;
                for(var i=0; i<editFields.value.length; i++){
                    var e=i+1;
                    editFields.value[i].number=e;
                    editFields.value[i].data.forEach(field => {
                    if (data[field.name]) {
                        field.value = data[field.name];
                    }
                    });
                }
            }else{
                call({
                    url:urls.transactions,
                    data:{deleteItem:id},
                    success:(res)=>{
                        if(res.status){
                            editFields.value=updatedFormSets;
                            for(var i=0; i<editFields.value.length; i++){
                                var e=i+1;
                                editFields.value[i].number=e;
                                editFields.value[i].data.forEach(field => {
                                if (data[field.name]) {
                                    field.value = data[field.name];
                                }
                                });
                            }
                            setTable(res.msg)
                        }else{
                            if(deleted.fieldIndex){
                                editFields.value[deleted.setIndex].data[deleted.fieldIndex].deleting=false;
                            }else{
                                editFields.value[deleted.setIndex].deleting=false;
                            }
                            setErrors(res.msg)
                            setTimeout(()=>{
                                state.errors=[]
                            },5000)
                        }
                    }
                })
            }
        }

        function deleteTemplate(i){
            var id=tableData.value.rows[i].id;
            var c=confirm("Are you sure you want to delete this template, this action cannot be undone");
            if(c){
                alert("Deleting")
                call({
                    url:urls.transactions,
                    data:{deleteTemplate:id},
                    success:(res)=>{
                        if(res.status){
                            setTable(res.msg)
                        }else{
                            alert(res.msg)
                        }
                    }
                })
            }
        }

        return{state,page,createNew,newFields,payacct,addTemplate,tableData,
        itemFields,addI,addMoreItem,addItem,editFields,editTemplate,editItem,
        deleteItem,addMoreEditItem,updateItem,deleteTemplate
        }
    }
}
</script>